import { read } from "./read"

export const ad = {
  read,
}
